<template>
  <div class="quiz-result">
    <div class="intro mb-3">
      Twoje motto: „Żyj i daj żyć innym”
    </div>

    <div class="cechy columns d-flex p-2">
      <div class="col-auto pt-3 images">
        <img :src="require('@/assets/images/segmentacja/thumb-tradycyjni-europejczycy.jpg')"
             alt="group thumbnail"
            class="img-responsive"/>
      </div>
      <div class="pl-4 pl-sm-0 description-col">
        <img :src="require('@/assets/images/segmentacja/icon-tradycyjni-europejczycy.png')"
             alt="group thumbnail"
             class="img-responsive mb-2 icon"/>
        <p>
          Jesteś dzieckiem Unii Europejskiej.
          Jest ona dla Ciebie gwarancją Twoich praw i&nbsp;Twoich obowiązków.
        </p>
        <p>
          Jesteś za tradycją, która szanuje rodzinę i&nbsp;zwyczaje.
          Uważasz, że każdy ma prawo do swoich poglądów i&nbsp;realizowania
          innych sposobów na życie.
          Nie lubisz oceniać innych i&nbsp;nie lubisz, kiedy Ciebie oceniają.
        </p>
        <p>
          Wiara w&nbsp;Boga jest dla Ciebie ważna,
          ale niekoniecznie pod okiem Kościoła Katolickiego.
        </p>
        <p>
          Bardzo przeszkadzają Ci podziały, które są w&nbsp;życiu prywatnym i&nbsp;społecznym.
          Nie lubisz konfrontacji, one pogłębiają podziały.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TradycyjniEuropejczycy',
};
</script>

<style scoped>
  .intro {
    color: #FFFFFF;
    background: var(--color-tradycyjni-europejczycy);
    font-size: 1.3em;
    font-weight: 700;
    padding: .6em .8em;
  }
</style>
